<app-header-content-footer *transloco="let t"
                           [headerTitle]="t('product-coupon')">
  <app-sidenav-content content showBanner>

    <app-product-coupon-vip-content *ngIf="couponVip"
    content
    [title]="getTitle()"
    label1="{{ t('product-coupon-vip-info-label-1') }}"
    label2="{{ t('product-coupon-vip-info-label-2') }}"
    label3="{{ t('copy-coupon-code') }}"
    [coupon]="couponVip"></app-product-coupon-vip-content>

    <app-product-coupon-content *ngIf="coupon"
                                content
                                [title]="getTitle()"
                                label1="{{ t('product-coupon-info-label-1') }}"
                                label2="{{ t('product-coupon-info-label-2') }}"
                                label3="{{ t('product-coupon-info-label-3') }}"
                                [coupon]="coupon"
      ></app-product-coupon-content>
  </app-sidenav-content>
</app-header-content-footer>
